import { Link } from 'react-router-dom';

const GUIDES = [
  {
    title: 'Best Luxury Cabins in Highlands NC',
    description: 'Our curated selection of the finest cabin rentals, from intimate retreats to grand mountain estates. Vetted for quality, comfort, and character.',
    tag: 'Cabin Guide',
    path: '/best-luxury-cabins',
    image: 'https://public.readdy.ai/ai/img_res/6044a5c257e402fb7339408e9769b2b6.jpg',
  },
  {
    title: 'Things to Do in Highlands NC',
    description: 'From legendary waterfalls and ancient mountain summits to acclaimed restaurants and artisan galleries — everything that makes Highlands unforgettable.',
    tag: 'Activity Guide',
    path: '/things-to-do',
    image: 'https://readdy.ai/api/search-image?query=hiker%20standing%20on%20granite%20cliff%20overlook%20at%20whiteside%20mountain%20Highlands%20North%20Carolina%20panoramic%20view%20of%20blue%20ridge%20mountains%20autumn%20foliage%20dramatic%20valleys%20below%20clear%20sky%20adventure%20travel%20photography%20golden%20afternoon%20light&width=720&height=480&seq=guide-activities-02&orientation=landscape',
  },
];

const QUICK_LINKS = [
  { label: 'Pet Friendly Cabins Highlands NC', icon: 'ri-heart-line', path: '/pet-friendly-cabins-highlands-nc' },
  { label: 'Cabins Near Glen Falls Waterfall', icon: 'ri-water-flash-line', path: '/cabins-near-glen-falls-highlands-nc' },
  { label: 'Cabins in Highlands NC', icon: 'ri-home-5-line', path: '/cabins-in-highlands-nc' },
  { label: 'Best Luxury Cabins', icon: 'ri-vip-crown-line', path: '/best-luxury-cabins' },
];

export default function GuideLinks() {
  return (
    <section className="bg-[#FAFAF8] py-28 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Explore the Guides</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            Your Complete<br /><em className="italic">Highlands Handbook</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {GUIDES.map((guide) => (
            <Link
              key={guide.path}
              to={guide.path}
              className="group relative overflow-hidden rounded-2xl cursor-pointer block"
            >
              <div className="overflow-hidden rounded-2xl h-72 relative">
                <img
                  src={guide.image}
                  alt={guide.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <span className="text-[#C9A96E] text-xs tracking-[0.2em] uppercase font-jost mb-3 block">{guide.tag}</span>
                  <h3 className="font-cormorant text-3xl text-white font-light leading-tight mb-2">{guide.title}</h3>
                  <p className="text-white/65 text-sm font-jost leading-relaxed">{guide.description}</p>
                  <div className="flex items-center gap-2 mt-4 text-white/80 text-xs font-jost tracking-widest uppercase">
                    <span>Read Guide</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-[#F5F1EB] rounded-2xl p-10">
          <p className="text-[#9C9890] text-xs tracking-[0.3em] uppercase font-jost text-center mb-8">Quick Searches</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {QUICK_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className="flex flex-col items-center gap-3 p-5 bg-white rounded-xl hover:bg-[#2D4A3E] group transition-colors duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F5F1EB] group-hover:bg-white/15 transition-colors">
                  <i className={`${link.icon} text-[#2D4A3E] group-hover:text-white text-lg transition-colors`} />
                </div>
                <span className="text-[#5C5850] group-hover:text-white text-xs font-jost text-center leading-snug transition-colors">{link.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}